import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const LocationFilter = ({ onLocationChange, onPriceRangeChange, className = "" }) => {
  const [selectedLocation, setSelectedLocation] = useState('all');
  const [selectedPriceRange, setSelectedPriceRange] = useState('all');
  const [isExpanded, setIsExpanded] = useState(false);

  const locationOptions = [
    { value: 'all', label: 'All Locations' },
    { value: 'serbia', label: 'Serbia' },
    { value: 'montenegro', label: 'Montenegro' },
    { value: 'belgrade', label: 'Belgrade Area' },
    { value: 'novi-sad', label: 'Novi Sad Area' },
    { value: 'podgorica', label: 'Podgorica Area' },
    { value: 'kotor', label: 'Kotor Bay Area' },
    { value: 'zlatibor', label: 'Zlatibor Region' },
    { value: 'durmitor', label: 'Durmitor Region' }
  ];

  const priceRangeOptions = [
    { value: 'all', label: 'All Prices' },
    { value: '0-25', label: '€0 - €25' },
    { value: '25-50', label: '€25 - €50' },
    { value: '50-100', label: '€50 - €100' },
    { value: '100-200', label: '€100 - €200' },
    { value: '200+', label: '€200+' }
  ];

  const handleLocationChange = (value) => {
    setSelectedLocation(value);
    onLocationChange(value);
  };

  const handlePriceRangeChange = (value) => {
    setSelectedPriceRange(value);
    onPriceRangeChange(value);
  };

  const clearFilters = () => {
    setSelectedLocation('all');
    setSelectedPriceRange('all');
    onLocationChange('all');
    onPriceRangeChange('all');
  };

  const hasActiveFilters = selectedLocation !== 'all' || selectedPriceRange !== 'all';

  return (
    <div className={`bg-card rounded-lg shadow-card ${className}`}>
      {/* Mobile Toggle */}
      <div className="lg:hidden">
        <Button
          variant="outline"
          onClick={() => setIsExpanded(!isExpanded)}
          className="w-full justify-between p-4"
          iconName={isExpanded ? 'ChevronUp' : 'ChevronDown'}
          iconPosition="right"
        >
          <div className="flex items-center gap-2">
            <Icon name="SlidersHorizontal" size={16} />
            <span>Advanced Filters</span>
            {hasActiveFilters && (
              <span className="bg-primary text-primary-foreground text-xs px-2 py-0.5 rounded-full">
                Active
              </span>
            )}
          </div>
        </Button>
        
        {isExpanded && (
          <div className="p-4 pt-0 space-y-4">
            <FilterContent
              locationOptions={locationOptions}
              priceRangeOptions={priceRangeOptions}
              selectedLocation={selectedLocation}
              selectedPriceRange={selectedPriceRange}
              onLocationChange={handleLocationChange}
              onPriceRangeChange={handlePriceRangeChange}
              onClearFilters={clearFilters}
              hasActiveFilters={hasActiveFilters}
            />
          </div>
        )}
      </div>

      {/* Desktop Always Visible */}
      <div className="hidden lg:block p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading font-semibold text-base">Advanced Filters</h3>
          {hasActiveFilters && (
            <Button
              variant="ghost"
              size="sm"
              onClick={clearFilters}
              iconName="X"
              iconPosition="left"
              iconSize={14}
            >
              Clear All
            </Button>
          )}
        </div>
        
        <FilterContent
          locationOptions={locationOptions}
          priceRangeOptions={priceRangeOptions}
          selectedLocation={selectedLocation}
          selectedPriceRange={selectedPriceRange}
          onLocationChange={handleLocationChange}
          onPriceRangeChange={handlePriceRangeChange}
          onClearFilters={clearFilters}
          hasActiveFilters={hasActiveFilters}
        />
      </div>
    </div>
  );
};

const FilterContent = ({
  locationOptions,
  priceRangeOptions,
  selectedLocation,
  selectedPriceRange,
  onLocationChange,
  onPriceRangeChange,
  onClearFilters,
  hasActiveFilters
}) => {
  return (
    <div className="space-y-4">
      <Select
        label="Location"
        options={locationOptions}
        value={selectedLocation}
        onChange={onLocationChange}
        placeholder="Select location"
      />
      
      <Select
        label="Price Range"
        options={priceRangeOptions}
        value={selectedPriceRange}
        onChange={onPriceRangeChange}
        placeholder="Select price range"
      />

      {hasActiveFilters && (
        <div className="pt-2 border-t border-border lg:hidden">
          <Button
            variant="outline"
            size="sm"
            onClick={onClearFilters}
            className="w-full"
            iconName="X"
            iconPosition="left"
            iconSize={14}
          >
            Clear All Filters
          </Button>
        </div>
      )}
    </div>
  );
};

export default LocationFilter;